import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class BigVIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#56b40a" d="M20.038,0.013 C31.100,0.013 40.067,8.960 40.067,19.998 C40.067,31.035 31.100,39.982 20.038,39.982 C8.976,39.982 0.009,31.035 0.009,19.998 C0.009,8.960 8.976,0.013 20.038,0.013 Z"/>,
    <path fill="#fff" d="M31.937,16.957 L18.666,30.198 C18.665,30.200 18.664,30.201 18.662,30.203 C18.105,30.759 17.376,31.036 16.646,31.036 C15.916,31.036 15.186,30.759 14.630,30.203 C14.628,30.201 14.627,30.200 14.626,30.198 L8.571,24.157 C7.458,23.046 7.458,21.245 8.571,20.134 C9.684,19.023 11.489,19.023 12.603,20.134 L16.646,24.169 L27.905,12.934 C29.019,11.823 30.824,11.823 31.937,12.934 C33.050,14.045 33.050,15.846 31.937,16.957 Z"/> ]
  getViewBox = () => '0 0 40 40'
}
